import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ButtonData = {
  buttonText: string
  link: string
  marginBottom?: string
  marginTop?: string
  btnType?: 'outline' | 'filled'
  btnColor?: 'customer' | 'light' | 'dark'
  alignment?: 'left' | 'center' | 'right'
}

export const button: DynamicContentType<ButtonData> = {
  name: 'button',
  viewName: 'Knapp',
  featureKey: 'button',
  icon: LucideIconName.Link,
  default: true,
  uuid: '',
  data: {
    btnType: 'filled',
    buttonText: 'Min knapp',
    link: '/',
    marginBottom: '1rem',
  },
}
